import { repositoryClient, toRepositoryBody } from "@/core/network/repository-client";
import type {
  NotificationListResponse,
  UnreadCountResponse,
  NotificationPreferences,
} from "../../types";
import type {
  NotificationListResponseDto,
  NotificationPreferencesDto,
  RegisterFcmTokenRequestDto,
  UnreadCountResponseDto,
} from "../dto/notification.dto";
import {
  mapNotificationListDto,
  mapNotificationPreferencesDto,
  mapUnreadCountDto,
} from "../mappers/notification.mapper";

const BASE = "/notifications/me";

export const notificationRepository = {
  async getNotifications(params?: {
    isRead?: boolean;
    limit?: number;
    offset?: number;
  }): Promise<NotificationListResponse> {
    const dto = await repositoryClient.get<NotificationListResponseDto>(BASE, {
      queryParams: {
        ...(params?.isRead !== undefined ? { isRead: params.isRead } : {}),
        ...(params?.limit !== undefined ? { limit: String(params.limit) } : {}),
        ...(params?.offset !== undefined ? { offset: String(params.offset) } : {}),
      },
    });

    return mapNotificationListDto(dto);
  },

  async getUnreadCount(): Promise<UnreadCountResponse> {
    const dto = await repositoryClient.get<UnreadCountResponseDto>(`${BASE}/unread-count`);

    return mapUnreadCountDto(dto);
  },

  async markAsRead(id: string): Promise<void> {
    await repositoryClient.patch(`${BASE}/${id}/read`);
  },

  async markAllAsRead(): Promise<void> {
    await repositoryClient.patch(`${BASE}/read-all`);
  },

  async getPreferences(): Promise<NotificationPreferences | null> {
    const dto = await repositoryClient.get<NotificationPreferencesDto | null>(
      `${BASE}/preferences`,
    );

    return mapNotificationPreferencesDto(dto);
  },

  async updatePreferences(prefs: Partial<NotificationPreferences>): Promise<void> {
    await repositoryClient.put(`${BASE}/preferences`, {
      body: toRepositoryBody(prefs),
    });
  },

  async registerFcmToken(token: string): Promise<void> {
    const body: RegisterFcmTokenRequestDto = { token, platform: "WEB" };
    await repositoryClient.post(`${BASE}/fcm-token`, {
      body: toRepositoryBody(body),
    });
  },
};
